<div class="container">
    <div class="row" style="display: flex; width: 100%; margin-top: 10px">
        <div class="flex-dir">
            <span class="mat-title">Enviar Notificação</span>
            <form [formGroup]="form">
                <div class="row">
                <mat-form-field appearance="outline">
                    <mat-label>Título da Notificação</mat-label>
                    <input type="text" matInput placeholder="Insira um Título" formControlName="title" id="title" />
                    <mat-error *ngIf="form.get('title').errors?.required">
                    Por favor informe o Título
                    </mat-error>
                </mat-form-field>
                </div>
        
                <div class="row">
                <mat-form-field appearance="outline">
                    <mat-label>Mensagem da Notificação</mat-label>
                    <textarea
                    matInput
                    placeholder="Escreva a sua mensagem aqui"
                    formControlName="message"
                    rows="7"
                    id="message"
                    ></textarea>
                    <mat-error *ngIf="form.get('message').errors?.required">
                    Por favor preencher o campo
                    </mat-error>
                </mat-form-field>
                </div>
        
                <div class="actions">
                <button mat-raised-button class="custom-primary" color="primary" (click)="submit()">
                    Enviar
                </button>
                </div>
            </form>
        </div>
    
        <div class="flex-esq">
            <ng-container *ngIf="dataSource.data.length > 0">
                <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                    <!-- Título da Notificação -->
                    <ng-container matColumnDef="title">
                    <th mat-header-cell *matHeaderCellDef> Título </th>
                    <td mat-cell *matCellDef="let notification"> {{notification.title}} </td>
                    </ng-container>
                
                    <!-- Mensagem da Notificação -->
                    <ng-container matColumnDef="message">
                    <th mat-header-cell *matHeaderCellDef> Mensagem </th>
                    <td mat-cell *matCellDef="let notification"> {{notification.message}} </td>
                    </ng-container>
                
                    <!-- Data da Notificação -->
                    <ng-container matColumnDef="data">
                    <th mat-header-cell *matHeaderCellDef> Data </th>
                    <td mat-cell *matCellDef="let notification"> {{notification.data}} </td>
                    </ng-container>
                
                    <!-- Table Header and Row Definitions -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                
                <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </ng-container>  
            <ng-container *ngIf="dataSource.data.length === 0">
                <div class="empty-content">
                    <span class="mat-body-2">Nenhuma Notificação Encontrada</span>
                </div>
            </ng-container>
        </div>
    </div>
</div>
  